export const FONT_FAMILY_OPTIONS = [
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Georgia',
  'Verdana',
  'Courier New',
  'Impact',
  'Comic Sans MS',
]

export const FONT_WEIGHT_OPTIONS = [
  { value: 'normal', label: 'PRESENTER.COMMON_TOOL_OPTIONS.FONT_WEIGHT_OPTIONS.NORMAL' },
  { value: 'bold', label: 'PRESENTER.COMMON_TOOL_OPTIONS.FONT_WEIGHT_OPTIONS.BOLD' },
  { value: '100', label: 'PRESENTER.COMMON_TOOL_OPTIONS.FONT_WEIGHT_OPTIONS.THIN' },
  { value: '300', label: 'PRESENTER.COMMON_TOOL_OPTIONS.FONT_WEIGHT_OPTIONS.LIGHT' },
  { value: '500', label: 'PRESENTER.COMMON_TOOL_OPTIONS.FONT_WEIGHT_OPTIONS.MEDIUM' },
  { value: '600', label: 'PRESENTER.COMMON_TOOL_OPTIONS.FONT_WEIGHT_OPTIONS.SEMIBOLD' },
  { value: '800', label: 'PRESENTER.COMMON_TOOL_OPTIONS.FONT_WEIGHT_OPTIONS.EXTRABOLD' },
]

export const FONT_STYLE_OPTIONS = [
  { value: 'normal', label: 'PRESENTER.TEXT_TOOLS.FONT_STYLES.NORMAL' },
  { value: 'italic', label: 'PRESENTER.TEXT_TOOLS.FONT_STYLES.ITALIC' },
  { value: 'oblique', label: 'PRESENTER.TEXT_TOOLS.FONT_STYLES.OBLIQUE' },
]

export const TEXT_ALIGN_OPTIONS = [
  { value: 'left', label: 'PRESENTER.COMMON_TOOL_OPTIONS.TEXT_ALIGN_OPTIONS.LEFT' },
  { value: 'center', label: 'PRESENTER.COMMON_TOOL_OPTIONS.TEXT_ALIGN_OPTIONS.CENTER' },
  { value: 'right', label: 'PRESENTER.COMMON_TOOL_OPTIONS.TEXT_ALIGN_OPTIONS.RIGHT' },
  { value: 'justify', label: 'PRESENTER.COMMON_TOOL_OPTIONS.TEXT_ALIGN_OPTIONS.JUSTIFY' },
]

export const TEXT_DECORATION_OPTIONS = [
  { value: 'none', label: 'PRESENTER.TEXT_TOOLS.TEXT_DECORATIONS.NONE' },
  { value: 'underline', label: 'PRESENTER.TEXT_TOOLS.TEXT_DECORATIONS.UNDERLINE' },
  { value: 'overline', label: 'PRESENTER.TEXT_TOOLS.TEXT_DECORATIONS.OVERLINE' },
  { value: 'line-through', label: 'PRESENTER.TEXT_TOOLS.TEXT_DECORATIONS.LINE_THROUGH' },
]

export const BORDER_STYLE_OPTIONS = [
  { value: 'solid', label: 'PRESENTER.COMMON_TOOL_OPTIONS.BORDER_STYLE_OPTIONS.SOLID' },
  { value: 'dashed', label: 'PRESENTER.COMMON_TOOL_OPTIONS.BORDER_STYLE_OPTIONS.DASHED' },
  { value: 'dotted', label: 'PRESENTER.COMMON_TOOL_OPTIONS.BORDER_STYLE_OPTIONS.DOTTED' },
  { value: 'double', label: 'PRESENTER.COMMON_TOOL_OPTIONS.BORDER_STYLE_OPTIONS.DOUBLE' },
  { value: 'none', label: 'PRESENTER.COMMON_TOOL_OPTIONS.BORDER_STYLE_OPTIONS.NONE' },
]
